export class Form {
    #isDirty = false;

    constructor(
        w = window,
        confirmMessage = 'Het lijkt er op dat je iets aan het bewerken bent. Als je weggaat zonder op te slaan, gaan je wijzigingen verloren.',
    ) {
        this.window = w;
        this.confirmMessage = confirmMessage;
        this.bindUnload();
    }

    clean() {
        return !this.#isDirty;
    }

    start() {
        this.#isDirty = true;
    }

    finish() {
        this.#isDirty = false;
    }

    confirmationMessage() {
        return this.confirmMessage;
    }

    bindUnload() {
        this.window.addEventListener('beforeunload', (e) => {
            if (this.clean()) {
                return undefined;
            }

            e.returnValue = this.confirmationMessage();
            return e.returnValue;
        });
    }
}
export default function bindToForm(formElement, message) {
    const form = new Form(window, message);

    for (const element of formElement.querySelectorAll('input,select,textarea')) {
        element.addEventListener('change', () => {
            form.start();
        });
    }

    formElement.addEventListener('change', () => {
        form.start();
    });

    formElement.addEventListener('submit', () => {
        form.finish();
    });

    return form;
}
